import MenuComponent from '@/components/MenuComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'

export default {
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated
  },
  data () {
    return {
      majAdresseMailPorteurList: []
    }
  },
  mounted () {
    this.loading = true
    this.$store.dispatch('user/getListeMajMails').then(
      response => {
        this.loading = false
        this.majAdresseMailPorteurList = response
      },
      error => {
        this.loading = false
        this.errorMessage = error.response
      }
    )
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Mise à jour de l\'adresse mail'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null
  }
}
